<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
        <div class="text-bodt-2 font-weight-black my-4">
          {{ componentData.sub }}
        </div>
      </v-col>
      <v-col>
        <v-form
          ref="form"
          v-model="componentData.formSetting.valid"
          lazy-validation
          @submit.prevent
        >
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signUpDate.email"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetErrorValidation"
            @keyup.enter="Mail_SendConfirmMail()"
          ></v-text-field>
          <div class="py-2"></div>
        </v-form>

        <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="Mail_SendConfirmMail()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.signup }}</span>
        </v-btn>

        <v-row class="d-flex">
          <v-col cols="6">
            <v-divider class="my-10"></v-divider>
          </v-col>
          <div class="my-11 body-2 text--disabled">
            {{ componentData.or }}
          </div>
          <v-col>
            <v-divider class="my-10"></v-divider>
          </v-col>
        </v-row>

        <v-btn
          block
          large
          outlined
          class="btn-gray-border"
          :loading="componentData.googleLoading"
          @click="GoogleSignupWithRefAPI()"
        >
          <v-img
            contain
            max-height="22.8"
            max-width="24"
            :src="componentData.googleLogo"
          ></v-img
          ><span class="mx-2 text-capitalize">{{
            componentData.googleLogin
          }}</span>
        </v-btn>

        <!-- <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="Mail_SendConfirmMail()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.signup }}</span>
        </v-btn> -->
        <div class="py-4"></div>
        <div>
          <span class="text-body-2">{{ componentData.haveAcc }} </span>

          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1 text-decoration-underline"
            plain
            @click="GoSignIn()"
          >
            {{ componentData.memberSignin }}
          </v-btn>
        </div>
        <div class="py-4"></div>
        <div class="text-body-2" align="left">
          {{ componentData.description.text1 }}
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1 text-decoration-underline"
            style="height: auto"
            plain
            @click="GoPage('Disclaimer')"
          >
            {{ componentData.description.text2 }}
          </v-btn>
          {{ componentData.description.text3 }}
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1 text-decoration-underline"
            style="height: auto"
            plain
            @click="GoPage('PrivacyPolicy')"
          >
            {{ componentData.description.text4 }}
          </v-btn>
          {{ componentData.description.text5 }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  Mail_SendConfirmMail,
  Google_Login,
  Google_SignupWithRef,
} from "@/apis/api";

export default {
  name: "SignUp",
  data() {
    return {
      componentData: {
        title: "免費會員註冊",
        sub: "註冊會員，享受小芋頭各式服務",
        formSetting: {
          valid: true,
          input1: {
            label: "帳號(電子信箱)",
            placeholder: "email",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) =>
                /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(
                  v
                ) || "格式錯誤，請重新輸入",
            ],
            errorMsg: "",
          },
        },
        forgotPwd: "忘記密碼?",
        or: "或",
        hint: "請輸入最少6個字元，混合英數字之密碼",
        googleLogo: require("@/assets/image/components/Google Icon.svg"),
        googleLogin: "以Google帳號註冊",
        signup: "下一步",
        haveAcc: "已經有小芋頭帳號?",
        memberSignin: "會員登入",
        loading: false,
        googleLoading: false,
        description: {
          text1: "透過Google, 或電子信箱註冊小芋頭會員，即表示您已閱讀並同意",
          text2: "免責聲明",
          text3: "與",
          text4: "隱私權政策",
          text5: "。",
        },
      },
      signUpDate: {
        email: null,
        password: null,
      },
    };
  },
  mounted() {
    if (this.$route.query.ivtem) {
      localStorage.setItem(
        "inviterQuery",
        `cmid=${this.$route.query.cmid}&ivtem=${this.$route.query.ivtem}`
      );
    } else {
      localStorage.removeItem("inviterQuery");
    }

    // AI平台前端過來得分享會員emailCode
    if (this.$route.query.refc) {
      localStorage.setItem("referral_code", this.$route.query.refc);
    } else {
      localStorage.removeItem("referral_code");
    }
  },
  methods: {
    GoPage(router) {
      let routeData = this.$router.resolve({ name: router });
      window.open(routeData.href, "_blank");
    },
    // 清除表單驗證
    ResetErrorValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
    },
    // 寄送驗證信
    Mail_SendConfirmMail() {
      // 欄位驗證
      this.$refs.form.validate();
      // 驗證不過直接回傳
      if (!this.$refs.form.validate()) return false;

      this.componentData.loading = true;

      let data = {
        email: this.signUpDate.email,
        communityID: this.$route.query.cmid,
        InviterEmail: this.$route.query.ivtem,
        ReferralCode: this.$route.query.refc,
      };
      // api;
      Mail_SendConfirmMail(data)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          localStorage.setItem("signupEmail", this.signUpDate.email);
          // 成功跳轉頁
          this.GoVerifyEmail();
        })
        .catch((err) => {
          this.componentData.loading = false;
          this.componentData.formSetting.input1.errorMsg =
            err.response.data.message;
        });
    },
    // Google登入
    GoogleSignIn() {
      this.componentData.googleLoading = true;
      Google_Login()
        .then((res) => {
          location.replace(res.data);
          //   console.log(res);
          this.componentData.googleLoading = false;
        })
        .then((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // Google 登入註冊帶推薦人
    GoogleSignupWithRefAPI() {
      let referred = localStorage.getItem("referral_code");
      Google_SignupWithRef(referred)
        .then((res) => {
          location.replace(res.data);
          //   console.log(res);
          this.componentData.googleLoading = false;
        })
        .then((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // 轉登入頁面
    GoSignIn() {
      this.$emit("switch", "SignIn");
    },
    // 轉重設密碼頁面
    GoResetPwd() {
      this.$emit("switch", "ResetPwd");
    },
    GoVerifyEmail() {
      this.$emit("switch", "VerifyEmail");
    },
  },
};
</script>
